export default __webpack_public_path__ + "static/media/flycash.ab84d621.png";